import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=389f0a50&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=389f0a50&prod&scoped=true&lang=css"
import style1 from "./NotificationsModal.vue?vue&type=style&index=1&id=389f0a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f0a50",
  null
  
)

export default component.exports